












import Vue from 'vue'
import Progress from './Progress.vue'

export default Vue.extend({
  name: 'Steps',
  components: {
    Progress,
  },
  props: {
    totalSteps: {
      type: Number,
      default: 5,
    },
    currentStep: {
      type: Number,
      default: 0,
    },
    text: {
      type: String,
      default: 'プロフィールを登録してください。',
    },
  },
})
